import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RoutineService } from '../services/routines.service';
import {
	deleteRoutineTemplate,
	editRoutineTemplate,
	getRoutineTemplates,
	setRoutineTemplates,
} from './routines.actions';
import { map, switchMap } from 'rxjs';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { TranslateService } from '@tolgee/ngx';

export class RoutineEffects {
	private readonly actions$ = inject(Actions);
	private readonly routineService = inject(RoutineService);
	private readonly notify = inject(IconSnackBarService);
	private readonly translateService = inject(TranslateService);

	getRoutineTemplates$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(getRoutineTemplates),
			switchMap(() => this.routineService.getRoutineTemplates()),
			map(routineTemplates => {
				return setRoutineTemplates({ routineTemplates });
			})
		);
	});

	editRoutineTemplate$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(editRoutineTemplate),
			switchMap(({ routineTemplate }) => {
				return this.routineService.editRoutineTemplate(routineTemplate);
			}),
			map(() => {
				return getRoutineTemplates({ silent: true });
			})
		);
	});

	deleteRouitineTemplate$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(deleteRoutineTemplate),
			switchMap(({ pk }) => {
				return this.routineService.deleteRoutineTemplate(pk);
			}),
			map((success: boolean) => {
				if (!success) {
					this.notify.error(
						this.translateService.instant('failed_delete_routine_template')
					);
				}
				this.notify.success(this.translateService.instant('routine_template_deleted'));
				return getRoutineTemplates({ silent: true });
			})
		);
	});
}
